import React from "react";
import { getRemoteValue } from "../../Utils/firebase";
import { INK } from "../../Utils/designTokens";

/**
 * CRL-3241: soft gradient visual panel on the right of the login page.
 * Fills the full column height so the page looks fullscreen on tall viewports.
 */
const HomePageBanner = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
        background:
          "linear-gradient(160deg, #EEF4F8 0%, #F4F1FB 100%)",
      }}
    >
      <div
        aria-hidden
        style={{
          position: "absolute",
          right: "-15%",
          bottom: "-20%",
          width: "70%",
          paddingTop: "70%",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(201,184,240,0.55) 0%, rgba(201,184,240,0) 70%)",
        }}
      />
      <div
        aria-hidden
        style={{
          position: "absolute",
          left: "-10%",
          top: "-15%",
          width: "55%",
          paddingTop: "55%",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(169,220,227,0.55) 0%, rgba(169,220,227,0) 70%)",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          lineHeight: "1.15",
          alignItems: "center",
          textAlign: "center",
          fontSize: "52px",
          color: INK,
          position: "relative",
          padding: "0 32px",
        }}
      >
        <div
          style={{
            fontWeight: 800,
          }}
        >
          {getRemoteValue("home_page_banner_text1")}
        </div>
        <div style={{ fontWeight: 500 }}>
          {getRemoteValue("home_page_banner_text2")}
        </div>
      </div>
    </div>
  );
};

export default HomePageBanner;
